import actions from "./action_types.js";
import axios from "axios";

export default {
    [actions.FETCH_TRANSFERS_FOR_LIST]: function (store) {
        return axios.get('/summaries/transfer-lists/transfers')
            .catch(error => console.log(error))
    },
    [actions.SAVE_LISTS]: function (store, data) {
        return axios.post('/summaries/transfer-lists', {transfers: data})
            .catch(error => {
                console.log(error);
            })
    },
    //błąd (422 z komunikatem) obsługiwany w widoku - alert z treścią
    [actions.GENERATE_KSEF_COLLECTIVE_IDENTIFIER]: function (store, data) {
        return axios.post('/summaries/transfer-lists/collective-identifier', data)
    }
}
